/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UnsupportedImport } from './routes/unsupported'
import { Route as SettingImport } from './routes/setting'
import { Route as SearchImport } from './routes/search'
import { Route as NotificationImport } from './routes/notification'
import { Route as LoginImport } from './routes/login'
import { Route as FollowingImport } from './routes/following'
import { Route as ExploreImport } from './routes/explore'
import { Route as ExperimentImport } from './routes/experiment'
import { Route as IndexImport } from './routes/index'
import { Route as UUsernameImport } from './routes/u.$username'
import { Route as HashtagIdImport } from './routes/hashtag.$id'
import { Route as testTestImport } from './routes/(test)/test'
import { Route as legacyRecommendImport } from './routes/(legacy)/recommend'
import { Route as legacyMeImport } from './routes/(legacy)/me'
import { Route as UUsernameIndexImport } from './routes/u.$username.index'
import { Route as TopicIdIndexImport } from './routes/topic.$id.index'
import { Route as UUsernameTopicImport } from './routes/u.$username.topic'
import { Route as UUsernameCollectionImport } from './routes/u.$username.collection'
import { Route as TopicIdTabImport } from './routes/topic.$id.$tab'
import { Route as testTestUnsupportedImport } from './routes/(test)/test.unsupported'
import { Route as testTestSearchImport } from './routes/(test)/test.search'
import { Route as testTestNavigateImport } from './routes/(test)/test.navigate'
import { Route as legacyUsersUsernameImport } from './routes/(legacy)/users.$username'
import { Route as legacyTopicsIdImport } from './routes/(legacy)/topics.$id'
import { Route as legacyRepostsIdImport } from './routes/(legacy)/reposts.$id'
import { Route as legacyRepostIdImport } from './routes/(legacy)/repost.$id'
import { Route as legacyOriginalPostsIdImport } from './routes/(legacy)/originalPosts.$id'
import { Route as legacyOriginalPostIdImport } from './routes/(legacy)/originalPost.$id'
import { Route as legacyHashtagsIdImport } from './routes/(legacy)/hashtags.$id'
import { Route as UUsernameTypeIdIndexImport } from './routes/u.$username_.$type.$id.index'
import { Route as UUsernameTypeIdCommentIdImport } from './routes/u.$username_.$type.$id.$commentId'

// Create Virtual Routes

const MoreLazyImport = createFileRoute('/more')()

// Create/Update Routes

const MoreLazyRoute = MoreLazyImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/more.lazy').then((d) => d.Route))

const UnsupportedRoute = UnsupportedImport.update({
  id: '/unsupported',
  path: '/unsupported',
  getParentRoute: () => rootRoute,
} as any)

const SettingRoute = SettingImport.update({
  id: '/setting',
  path: '/setting',
  getParentRoute: () => rootRoute,
} as any)

const SearchRoute = SearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRoute,
} as any)

const NotificationRoute = NotificationImport.update({
  id: '/notification',
  path: '/notification',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const FollowingRoute = FollowingImport.update({
  id: '/following',
  path: '/following',
  getParentRoute: () => rootRoute,
} as any)

const ExploreRoute = ExploreImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRoute,
} as any)

const ExperimentRoute = ExperimentImport.update({
  id: '/experiment',
  path: '/experiment',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UUsernameRoute = UUsernameImport.update({
  id: '/u/$username',
  path: '/u/$username',
  getParentRoute: () => rootRoute,
} as any)

const HashtagIdRoute = HashtagIdImport.update({
  id: '/hashtag/$id',
  path: '/hashtag/$id',
  getParentRoute: () => rootRoute,
} as any)

const testTestRoute = testTestImport.update({
  id: '/(test)/test',
  path: '/test',
  getParentRoute: () => rootRoute,
} as any)

const legacyRecommendRoute = legacyRecommendImport.update({
  id: '/(legacy)/recommend',
  path: '/recommend',
  getParentRoute: () => rootRoute,
} as any)

const legacyMeRoute = legacyMeImport.update({
  id: '/(legacy)/me',
  path: '/me',
  getParentRoute: () => rootRoute,
} as any)

const UUsernameIndexRoute = UUsernameIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UUsernameRoute,
} as any)

const TopicIdIndexRoute = TopicIdIndexImport.update({
  id: '/topic/$id/',
  path: '/topic/$id/',
  getParentRoute: () => rootRoute,
} as any)

const UUsernameTopicRoute = UUsernameTopicImport.update({
  id: '/topic',
  path: '/topic',
  getParentRoute: () => UUsernameRoute,
} as any)

const UUsernameCollectionRoute = UUsernameCollectionImport.update({
  id: '/collection',
  path: '/collection',
  getParentRoute: () => UUsernameRoute,
} as any)

const TopicIdTabRoute = TopicIdTabImport.update({
  id: '/topic/$id/$tab',
  path: '/topic/$id/$tab',
  getParentRoute: () => rootRoute,
} as any)

const testTestUnsupportedRoute = testTestUnsupportedImport.update({
  id: '/unsupported',
  path: '/unsupported',
  getParentRoute: () => testTestRoute,
} as any)

const testTestSearchRoute = testTestSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => testTestRoute,
} as any)

const testTestNavigateRoute = testTestNavigateImport.update({
  id: '/navigate',
  path: '/navigate',
  getParentRoute: () => testTestRoute,
} as any)

const legacyUsersUsernameRoute = legacyUsersUsernameImport.update({
  id: '/(legacy)/users/$username',
  path: '/users/$username',
  getParentRoute: () => rootRoute,
} as any)

const legacyTopicsIdRoute = legacyTopicsIdImport.update({
  id: '/(legacy)/topics/$id',
  path: '/topics/$id',
  getParentRoute: () => rootRoute,
} as any)

const legacyRepostsIdRoute = legacyRepostsIdImport.update({
  id: '/(legacy)/reposts/$id',
  path: '/reposts/$id',
  getParentRoute: () => rootRoute,
} as any)

const legacyRepostIdRoute = legacyRepostIdImport.update({
  id: '/(legacy)/repost/$id',
  path: '/repost/$id',
  getParentRoute: () => rootRoute,
} as any)

const legacyOriginalPostsIdRoute = legacyOriginalPostsIdImport.update({
  id: '/(legacy)/originalPosts/$id',
  path: '/originalPosts/$id',
  getParentRoute: () => rootRoute,
} as any)

const legacyOriginalPostIdRoute = legacyOriginalPostIdImport.update({
  id: '/(legacy)/originalPost/$id',
  path: '/originalPost/$id',
  getParentRoute: () => rootRoute,
} as any)

const legacyHashtagsIdRoute = legacyHashtagsIdImport.update({
  id: '/(legacy)/hashtags/$id',
  path: '/hashtags/$id',
  getParentRoute: () => rootRoute,
} as any)

const UUsernameTypeIdIndexRoute = UUsernameTypeIdIndexImport.update({
  id: '/u/$username_/$type/$id/',
  path: '/u/$username/$type/$id/',
  getParentRoute: () => rootRoute,
} as any)

const UUsernameTypeIdCommentIdRoute = UUsernameTypeIdCommentIdImport.update({
  id: '/u/$username_/$type/$id/$commentId',
  path: '/u/$username/$type/$id/$commentId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/experiment': {
      id: '/experiment'
      path: '/experiment'
      fullPath: '/experiment'
      preLoaderRoute: typeof ExperimentImport
      parentRoute: typeof rootRoute
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreImport
      parentRoute: typeof rootRoute
    }
    '/following': {
      id: '/following'
      path: '/following'
      fullPath: '/following'
      preLoaderRoute: typeof FollowingImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/notification': {
      id: '/notification'
      path: '/notification'
      fullPath: '/notification'
      preLoaderRoute: typeof NotificationImport
      parentRoute: typeof rootRoute
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchImport
      parentRoute: typeof rootRoute
    }
    '/setting': {
      id: '/setting'
      path: '/setting'
      fullPath: '/setting'
      preLoaderRoute: typeof SettingImport
      parentRoute: typeof rootRoute
    }
    '/unsupported': {
      id: '/unsupported'
      path: '/unsupported'
      fullPath: '/unsupported'
      preLoaderRoute: typeof UnsupportedImport
      parentRoute: typeof rootRoute
    }
    '/more': {
      id: '/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof MoreLazyImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/me': {
      id: '/(legacy)/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof legacyMeImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/recommend': {
      id: '/(legacy)/recommend'
      path: '/recommend'
      fullPath: '/recommend'
      preLoaderRoute: typeof legacyRecommendImport
      parentRoute: typeof rootRoute
    }
    '/(test)/test': {
      id: '/(test)/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof testTestImport
      parentRoute: typeof rootRoute
    }
    '/hashtag/$id': {
      id: '/hashtag/$id'
      path: '/hashtag/$id'
      fullPath: '/hashtag/$id'
      preLoaderRoute: typeof HashtagIdImport
      parentRoute: typeof rootRoute
    }
    '/u/$username': {
      id: '/u/$username'
      path: '/u/$username'
      fullPath: '/u/$username'
      preLoaderRoute: typeof UUsernameImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/hashtags/$id': {
      id: '/(legacy)/hashtags/$id'
      path: '/hashtags/$id'
      fullPath: '/hashtags/$id'
      preLoaderRoute: typeof legacyHashtagsIdImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/originalPost/$id': {
      id: '/(legacy)/originalPost/$id'
      path: '/originalPost/$id'
      fullPath: '/originalPost/$id'
      preLoaderRoute: typeof legacyOriginalPostIdImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/originalPosts/$id': {
      id: '/(legacy)/originalPosts/$id'
      path: '/originalPosts/$id'
      fullPath: '/originalPosts/$id'
      preLoaderRoute: typeof legacyOriginalPostsIdImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/repost/$id': {
      id: '/(legacy)/repost/$id'
      path: '/repost/$id'
      fullPath: '/repost/$id'
      preLoaderRoute: typeof legacyRepostIdImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/reposts/$id': {
      id: '/(legacy)/reposts/$id'
      path: '/reposts/$id'
      fullPath: '/reposts/$id'
      preLoaderRoute: typeof legacyRepostsIdImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/topics/$id': {
      id: '/(legacy)/topics/$id'
      path: '/topics/$id'
      fullPath: '/topics/$id'
      preLoaderRoute: typeof legacyTopicsIdImport
      parentRoute: typeof rootRoute
    }
    '/(legacy)/users/$username': {
      id: '/(legacy)/users/$username'
      path: '/users/$username'
      fullPath: '/users/$username'
      preLoaderRoute: typeof legacyUsersUsernameImport
      parentRoute: typeof rootRoute
    }
    '/(test)/test/navigate': {
      id: '/(test)/test/navigate'
      path: '/navigate'
      fullPath: '/test/navigate'
      preLoaderRoute: typeof testTestNavigateImport
      parentRoute: typeof testTestImport
    }
    '/(test)/test/search': {
      id: '/(test)/test/search'
      path: '/search'
      fullPath: '/test/search'
      preLoaderRoute: typeof testTestSearchImport
      parentRoute: typeof testTestImport
    }
    '/(test)/test/unsupported': {
      id: '/(test)/test/unsupported'
      path: '/unsupported'
      fullPath: '/test/unsupported'
      preLoaderRoute: typeof testTestUnsupportedImport
      parentRoute: typeof testTestImport
    }
    '/topic/$id/$tab': {
      id: '/topic/$id/$tab'
      path: '/topic/$id/$tab'
      fullPath: '/topic/$id/$tab'
      preLoaderRoute: typeof TopicIdTabImport
      parentRoute: typeof rootRoute
    }
    '/u/$username/collection': {
      id: '/u/$username/collection'
      path: '/collection'
      fullPath: '/u/$username/collection'
      preLoaderRoute: typeof UUsernameCollectionImport
      parentRoute: typeof UUsernameImport
    }
    '/u/$username/topic': {
      id: '/u/$username/topic'
      path: '/topic'
      fullPath: '/u/$username/topic'
      preLoaderRoute: typeof UUsernameTopicImport
      parentRoute: typeof UUsernameImport
    }
    '/topic/$id/': {
      id: '/topic/$id/'
      path: '/topic/$id'
      fullPath: '/topic/$id'
      preLoaderRoute: typeof TopicIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/u/$username/': {
      id: '/u/$username/'
      path: '/'
      fullPath: '/u/$username/'
      preLoaderRoute: typeof UUsernameIndexImport
      parentRoute: typeof UUsernameImport
    }
    '/u/$username_/$type/$id/$commentId': {
      id: '/u/$username_/$type/$id/$commentId'
      path: '/u/$username/$type/$id/$commentId'
      fullPath: '/u/$username/$type/$id/$commentId'
      preLoaderRoute: typeof UUsernameTypeIdCommentIdImport
      parentRoute: typeof rootRoute
    }
    '/u/$username_/$type/$id/': {
      id: '/u/$username_/$type/$id/'
      path: '/u/$username/$type/$id'
      fullPath: '/u/$username/$type/$id'
      preLoaderRoute: typeof UUsernameTypeIdIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface testTestRouteChildren {
  testTestNavigateRoute: typeof testTestNavigateRoute
  testTestSearchRoute: typeof testTestSearchRoute
  testTestUnsupportedRoute: typeof testTestUnsupportedRoute
}

const testTestRouteChildren: testTestRouteChildren = {
  testTestNavigateRoute: testTestNavigateRoute,
  testTestSearchRoute: testTestSearchRoute,
  testTestUnsupportedRoute: testTestUnsupportedRoute,
}

const testTestRouteWithChildren = testTestRoute._addFileChildren(
  testTestRouteChildren,
)

interface UUsernameRouteChildren {
  UUsernameCollectionRoute: typeof UUsernameCollectionRoute
  UUsernameTopicRoute: typeof UUsernameTopicRoute
  UUsernameIndexRoute: typeof UUsernameIndexRoute
}

const UUsernameRouteChildren: UUsernameRouteChildren = {
  UUsernameCollectionRoute: UUsernameCollectionRoute,
  UUsernameTopicRoute: UUsernameTopicRoute,
  UUsernameIndexRoute: UUsernameIndexRoute,
}

const UUsernameRouteWithChildren = UUsernameRoute._addFileChildren(
  UUsernameRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/experiment': typeof ExperimentRoute
  '/explore': typeof ExploreRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notification': typeof NotificationRoute
  '/search': typeof SearchRoute
  '/setting': typeof SettingRoute
  '/unsupported': typeof UnsupportedRoute
  '/more': typeof MoreLazyRoute
  '/me': typeof legacyMeRoute
  '/recommend': typeof legacyRecommendRoute
  '/test': typeof testTestRouteWithChildren
  '/hashtag/$id': typeof HashtagIdRoute
  '/u/$username': typeof UUsernameRouteWithChildren
  '/hashtags/$id': typeof legacyHashtagsIdRoute
  '/originalPost/$id': typeof legacyOriginalPostIdRoute
  '/originalPosts/$id': typeof legacyOriginalPostsIdRoute
  '/repost/$id': typeof legacyRepostIdRoute
  '/reposts/$id': typeof legacyRepostsIdRoute
  '/topics/$id': typeof legacyTopicsIdRoute
  '/users/$username': typeof legacyUsersUsernameRoute
  '/test/navigate': typeof testTestNavigateRoute
  '/test/search': typeof testTestSearchRoute
  '/test/unsupported': typeof testTestUnsupportedRoute
  '/topic/$id/$tab': typeof TopicIdTabRoute
  '/u/$username/collection': typeof UUsernameCollectionRoute
  '/u/$username/topic': typeof UUsernameTopicRoute
  '/topic/$id': typeof TopicIdIndexRoute
  '/u/$username/': typeof UUsernameIndexRoute
  '/u/$username/$type/$id/$commentId': typeof UUsernameTypeIdCommentIdRoute
  '/u/$username/$type/$id': typeof UUsernameTypeIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/experiment': typeof ExperimentRoute
  '/explore': typeof ExploreRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notification': typeof NotificationRoute
  '/search': typeof SearchRoute
  '/setting': typeof SettingRoute
  '/unsupported': typeof UnsupportedRoute
  '/more': typeof MoreLazyRoute
  '/me': typeof legacyMeRoute
  '/recommend': typeof legacyRecommendRoute
  '/test': typeof testTestRouteWithChildren
  '/hashtag/$id': typeof HashtagIdRoute
  '/hashtags/$id': typeof legacyHashtagsIdRoute
  '/originalPost/$id': typeof legacyOriginalPostIdRoute
  '/originalPosts/$id': typeof legacyOriginalPostsIdRoute
  '/repost/$id': typeof legacyRepostIdRoute
  '/reposts/$id': typeof legacyRepostsIdRoute
  '/topics/$id': typeof legacyTopicsIdRoute
  '/users/$username': typeof legacyUsersUsernameRoute
  '/test/navigate': typeof testTestNavigateRoute
  '/test/search': typeof testTestSearchRoute
  '/test/unsupported': typeof testTestUnsupportedRoute
  '/topic/$id/$tab': typeof TopicIdTabRoute
  '/u/$username/collection': typeof UUsernameCollectionRoute
  '/u/$username/topic': typeof UUsernameTopicRoute
  '/topic/$id': typeof TopicIdIndexRoute
  '/u/$username': typeof UUsernameIndexRoute
  '/u/$username/$type/$id/$commentId': typeof UUsernameTypeIdCommentIdRoute
  '/u/$username/$type/$id': typeof UUsernameTypeIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/experiment': typeof ExperimentRoute
  '/explore': typeof ExploreRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notification': typeof NotificationRoute
  '/search': typeof SearchRoute
  '/setting': typeof SettingRoute
  '/unsupported': typeof UnsupportedRoute
  '/more': typeof MoreLazyRoute
  '/(legacy)/me': typeof legacyMeRoute
  '/(legacy)/recommend': typeof legacyRecommendRoute
  '/(test)/test': typeof testTestRouteWithChildren
  '/hashtag/$id': typeof HashtagIdRoute
  '/u/$username': typeof UUsernameRouteWithChildren
  '/(legacy)/hashtags/$id': typeof legacyHashtagsIdRoute
  '/(legacy)/originalPost/$id': typeof legacyOriginalPostIdRoute
  '/(legacy)/originalPosts/$id': typeof legacyOriginalPostsIdRoute
  '/(legacy)/repost/$id': typeof legacyRepostIdRoute
  '/(legacy)/reposts/$id': typeof legacyRepostsIdRoute
  '/(legacy)/topics/$id': typeof legacyTopicsIdRoute
  '/(legacy)/users/$username': typeof legacyUsersUsernameRoute
  '/(test)/test/navigate': typeof testTestNavigateRoute
  '/(test)/test/search': typeof testTestSearchRoute
  '/(test)/test/unsupported': typeof testTestUnsupportedRoute
  '/topic/$id/$tab': typeof TopicIdTabRoute
  '/u/$username/collection': typeof UUsernameCollectionRoute
  '/u/$username/topic': typeof UUsernameTopicRoute
  '/topic/$id/': typeof TopicIdIndexRoute
  '/u/$username/': typeof UUsernameIndexRoute
  '/u/$username_/$type/$id/$commentId': typeof UUsernameTypeIdCommentIdRoute
  '/u/$username_/$type/$id/': typeof UUsernameTypeIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/experiment'
    | '/explore'
    | '/following'
    | '/login'
    | '/notification'
    | '/search'
    | '/setting'
    | '/unsupported'
    | '/more'
    | '/me'
    | '/recommend'
    | '/test'
    | '/hashtag/$id'
    | '/u/$username'
    | '/hashtags/$id'
    | '/originalPost/$id'
    | '/originalPosts/$id'
    | '/repost/$id'
    | '/reposts/$id'
    | '/topics/$id'
    | '/users/$username'
    | '/test/navigate'
    | '/test/search'
    | '/test/unsupported'
    | '/topic/$id/$tab'
    | '/u/$username/collection'
    | '/u/$username/topic'
    | '/topic/$id'
    | '/u/$username/'
    | '/u/$username/$type/$id/$commentId'
    | '/u/$username/$type/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/experiment'
    | '/explore'
    | '/following'
    | '/login'
    | '/notification'
    | '/search'
    | '/setting'
    | '/unsupported'
    | '/more'
    | '/me'
    | '/recommend'
    | '/test'
    | '/hashtag/$id'
    | '/hashtags/$id'
    | '/originalPost/$id'
    | '/originalPosts/$id'
    | '/repost/$id'
    | '/reposts/$id'
    | '/topics/$id'
    | '/users/$username'
    | '/test/navigate'
    | '/test/search'
    | '/test/unsupported'
    | '/topic/$id/$tab'
    | '/u/$username/collection'
    | '/u/$username/topic'
    | '/topic/$id'
    | '/u/$username'
    | '/u/$username/$type/$id/$commentId'
    | '/u/$username/$type/$id'
  id:
    | '__root__'
    | '/'
    | '/experiment'
    | '/explore'
    | '/following'
    | '/login'
    | '/notification'
    | '/search'
    | '/setting'
    | '/unsupported'
    | '/more'
    | '/(legacy)/me'
    | '/(legacy)/recommend'
    | '/(test)/test'
    | '/hashtag/$id'
    | '/u/$username'
    | '/(legacy)/hashtags/$id'
    | '/(legacy)/originalPost/$id'
    | '/(legacy)/originalPosts/$id'
    | '/(legacy)/repost/$id'
    | '/(legacy)/reposts/$id'
    | '/(legacy)/topics/$id'
    | '/(legacy)/users/$username'
    | '/(test)/test/navigate'
    | '/(test)/test/search'
    | '/(test)/test/unsupported'
    | '/topic/$id/$tab'
    | '/u/$username/collection'
    | '/u/$username/topic'
    | '/topic/$id/'
    | '/u/$username/'
    | '/u/$username_/$type/$id/$commentId'
    | '/u/$username_/$type/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ExperimentRoute: typeof ExperimentRoute
  ExploreRoute: typeof ExploreRoute
  FollowingRoute: typeof FollowingRoute
  LoginRoute: typeof LoginRoute
  NotificationRoute: typeof NotificationRoute
  SearchRoute: typeof SearchRoute
  SettingRoute: typeof SettingRoute
  UnsupportedRoute: typeof UnsupportedRoute
  MoreLazyRoute: typeof MoreLazyRoute
  legacyMeRoute: typeof legacyMeRoute
  legacyRecommendRoute: typeof legacyRecommendRoute
  testTestRoute: typeof testTestRouteWithChildren
  HashtagIdRoute: typeof HashtagIdRoute
  UUsernameRoute: typeof UUsernameRouteWithChildren
  legacyHashtagsIdRoute: typeof legacyHashtagsIdRoute
  legacyOriginalPostIdRoute: typeof legacyOriginalPostIdRoute
  legacyOriginalPostsIdRoute: typeof legacyOriginalPostsIdRoute
  legacyRepostIdRoute: typeof legacyRepostIdRoute
  legacyRepostsIdRoute: typeof legacyRepostsIdRoute
  legacyTopicsIdRoute: typeof legacyTopicsIdRoute
  legacyUsersUsernameRoute: typeof legacyUsersUsernameRoute
  TopicIdTabRoute: typeof TopicIdTabRoute
  TopicIdIndexRoute: typeof TopicIdIndexRoute
  UUsernameTypeIdCommentIdRoute: typeof UUsernameTypeIdCommentIdRoute
  UUsernameTypeIdIndexRoute: typeof UUsernameTypeIdIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ExperimentRoute: ExperimentRoute,
  ExploreRoute: ExploreRoute,
  FollowingRoute: FollowingRoute,
  LoginRoute: LoginRoute,
  NotificationRoute: NotificationRoute,
  SearchRoute: SearchRoute,
  SettingRoute: SettingRoute,
  UnsupportedRoute: UnsupportedRoute,
  MoreLazyRoute: MoreLazyRoute,
  legacyMeRoute: legacyMeRoute,
  legacyRecommendRoute: legacyRecommendRoute,
  testTestRoute: testTestRouteWithChildren,
  HashtagIdRoute: HashtagIdRoute,
  UUsernameRoute: UUsernameRouteWithChildren,
  legacyHashtagsIdRoute: legacyHashtagsIdRoute,
  legacyOriginalPostIdRoute: legacyOriginalPostIdRoute,
  legacyOriginalPostsIdRoute: legacyOriginalPostsIdRoute,
  legacyRepostIdRoute: legacyRepostIdRoute,
  legacyRepostsIdRoute: legacyRepostsIdRoute,
  legacyTopicsIdRoute: legacyTopicsIdRoute,
  legacyUsersUsernameRoute: legacyUsersUsernameRoute,
  TopicIdTabRoute: TopicIdTabRoute,
  TopicIdIndexRoute: TopicIdIndexRoute,
  UUsernameTypeIdCommentIdRoute: UUsernameTypeIdCommentIdRoute,
  UUsernameTypeIdIndexRoute: UUsernameTypeIdIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/experiment",
        "/explore",
        "/following",
        "/login",
        "/notification",
        "/search",
        "/setting",
        "/unsupported",
        "/more",
        "/(legacy)/me",
        "/(legacy)/recommend",
        "/(test)/test",
        "/hashtag/$id",
        "/u/$username",
        "/(legacy)/hashtags/$id",
        "/(legacy)/originalPost/$id",
        "/(legacy)/originalPosts/$id",
        "/(legacy)/repost/$id",
        "/(legacy)/reposts/$id",
        "/(legacy)/topics/$id",
        "/(legacy)/users/$username",
        "/topic/$id/$tab",
        "/topic/$id/",
        "/u/$username_/$type/$id/$commentId",
        "/u/$username_/$type/$id/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/experiment": {
      "filePath": "experiment.tsx"
    },
    "/explore": {
      "filePath": "explore.tsx"
    },
    "/following": {
      "filePath": "following.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/notification": {
      "filePath": "notification.tsx"
    },
    "/search": {
      "filePath": "search.tsx"
    },
    "/setting": {
      "filePath": "setting.tsx"
    },
    "/unsupported": {
      "filePath": "unsupported.tsx"
    },
    "/more": {
      "filePath": "more.lazy.tsx"
    },
    "/(legacy)/me": {
      "filePath": "(legacy)/me.tsx"
    },
    "/(legacy)/recommend": {
      "filePath": "(legacy)/recommend.tsx"
    },
    "/(test)/test": {
      "filePath": "(test)/test.tsx",
      "children": [
        "/(test)/test/navigate",
        "/(test)/test/search",
        "/(test)/test/unsupported"
      ]
    },
    "/hashtag/$id": {
      "filePath": "hashtag.$id.tsx"
    },
    "/u/$username": {
      "filePath": "u.$username.tsx",
      "children": [
        "/u/$username/collection",
        "/u/$username/topic",
        "/u/$username/"
      ]
    },
    "/(legacy)/hashtags/$id": {
      "filePath": "(legacy)/hashtags.$id.tsx"
    },
    "/(legacy)/originalPost/$id": {
      "filePath": "(legacy)/originalPost.$id.tsx"
    },
    "/(legacy)/originalPosts/$id": {
      "filePath": "(legacy)/originalPosts.$id.tsx"
    },
    "/(legacy)/repost/$id": {
      "filePath": "(legacy)/repost.$id.tsx"
    },
    "/(legacy)/reposts/$id": {
      "filePath": "(legacy)/reposts.$id.tsx"
    },
    "/(legacy)/topics/$id": {
      "filePath": "(legacy)/topics.$id.tsx"
    },
    "/(legacy)/users/$username": {
      "filePath": "(legacy)/users.$username.tsx"
    },
    "/(test)/test/navigate": {
      "filePath": "(test)/test.navigate.tsx",
      "parent": "/(test)/test"
    },
    "/(test)/test/search": {
      "filePath": "(test)/test.search.tsx",
      "parent": "/(test)/test"
    },
    "/(test)/test/unsupported": {
      "filePath": "(test)/test.unsupported.tsx",
      "parent": "/(test)/test"
    },
    "/topic/$id/$tab": {
      "filePath": "topic.$id.$tab.tsx"
    },
    "/u/$username/collection": {
      "filePath": "u.$username.collection.tsx",
      "parent": "/u/$username"
    },
    "/u/$username/topic": {
      "filePath": "u.$username.topic.tsx",
      "parent": "/u/$username"
    },
    "/topic/$id/": {
      "filePath": "topic.$id.index.tsx"
    },
    "/u/$username/": {
      "filePath": "u.$username.index.tsx",
      "parent": "/u/$username"
    },
    "/u/$username_/$type/$id/$commentId": {
      "filePath": "u.$username_.$type.$id.$commentId.tsx"
    },
    "/u/$username_/$type/$id/": {
      "filePath": "u.$username_.$type.$id.index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
